import { render, staticRenderFns } from "./MailboxSettings.vue?vue&type=template&id=9114b0fa&scoped=true"
import script from "./MailboxSettings.vue?vue&type=script&lang=ts"
export * from "./MailboxSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9114b0fa",
  null
  
)

export default component.exports